import {
  IAccountingSuggestion,
  PostingMode,
  getSuggestionDefaultAccrualDate,
  getSuggestionDefaultPostingMode
} from '@root/query/suggestions'

export const getDefaultPostingMode = (suggestion: IAccountingSuggestion): PostingMode => {
  return getSuggestionDefaultPostingMode(suggestion)
}

export const getDefaultAccrualDate = (suggestion: IAccountingSuggestion): string | null => {
  return getSuggestionDefaultAccrualDate(suggestion)
}

export const areAttachmentIdsEqual = (left: number[], right: number[]) => {
  if (left.length !== right.length) return false
  return left.every((id, index) => id === right[index])
}
